import { View, Header } from '@fairygodboss/ui';
import Cookies from 'js-cookie';
import React from 'react';

import { UseModalState } from '../../context/ModalContext';
import { fireGTMMetric } from '../../utils/Analytics/Google';
import { EmitMetric } from '../../utils/Analytics/VisibilityPixel/VisibilityPixel';
import { FGBLocalStorage } from '../../utils/helpers/FGBStorage';
import { QuickProfile } from '../QuickProfile/QuickProfile';

const Layout = ({
    children, user, userLoading, statusLoading
}) => {
    const {
        setModalOpen,
        setModal,
        setIsPayWall,
        setLayoutType,
        setLeadInLogin,
        setAuth0,
        setLeadInPopup,
        setLoginMetrics,
        errorPage,
    } = UseModalState();

    const [isMounted, setIsMounted] = React.useState(false);

    const onFireSignUpMetric = () => {
        const signUpTrigger = Cookies.get('REGISTRATION-TRIGGER');
        let loginMetrics = {};
        if (window) {
            loginMetrics = FGBLocalStorage.getItem('last_login_metrics') || {};
        }
        if (signUpTrigger && signUpTrigger !== 'OFF') {
            const loginCookie = {};
            if (Cookies.get('LOGIN-TRIGGER')) {
                loginCookie.login_trigger = Cookies.get('LOGIN-TRIGGER');
            }
            EmitMetric({
                registration_source: signUpTrigger,
                user_registered: 1,
                ...loginMetrics,
                ...loginCookie,
            });
        }

        if (user.isLoggedIn) {
            fireGTMMetric(
                'user-registered',
                '',
                '',
                {
                    userId: user.id,
                    userRegistration: '1',
                    label: 'registration',
                    category: 'userRegistered',
                },
                'dataLayer'
            );
            Cookies.set('REGISTRATION-TRIGGER', 'OFF');
        }
    };

    React.useEffect(() => {
        setIsMounted(true);
        onFireSignUpMetric();
    }, []);

    return (
        <>
            <header>
                <style global jsx>
                    {`
                        .logoWide {
                            margin-top: 20px;
                        }
                        .tempHead {
                            background-color: #7d268b;
                            height: 56px;
                            position: fixed;
                            top: 0;
                            width: 100%;
                        }
                        .userInfo img {
                            max-height: 48px;
                        }
                        @media screen and (min-width: 905px) {
                            .tempHead {
                                height: 68px;
                            }
                        }
                    `}
                </style>
                <div className="page-header">
                    <Header
                        errorPage={
                            errorPage
                            || userLoading
                            || statusLoading
                            || !isMounted
                        }
                        user={
                            isMounted
                            && !userLoading
                            && user.isLoggedIn
                            && !statusLoading
                                ? user
                                : null
                        }
                        useOldBreakpoints
                        onSignupClick={() => {
                            setIsPayWall(false);
                            setLayoutType(String('create'));
                            setLeadInLogin(false);
                            setLeadInPopup(false);
                            setAuth0(null);
                            setLoginMetrics(null);
                            setModal('signup');
                            setModalOpen(true);
                        }}
                        onSigninClick={() => {
                            setIsPayWall(false);
                            setLayoutType(String('login'));
                            setLeadInLogin(false);
                            setLeadInPopup(false);
                            setAuth0(null);
                            setLoginMetrics(null);
                            setModal('signin');
                            setModalOpen(true);
                        }}
                        emitMetric={EmitMetric}
                    />
                </div>
            </header>
            <span />
            {isMounted && !userLoading && user.isLoggedIn && (
                <QuickProfile userName={user.username} />
            )}
            <View
                backgroundColor="white"
                width="100%"
                ml="auto"
                mr="auto"
                mt={{ _: '100px', md: '68px' }}
            >
                {children}
            </View>
        </>
    );
};

export default Layout;
